import { createFileRoute } from '@tanstack/react-router';
import { validateCreateBroadcastSearch } from '@/pages/workspaces/broadcasts/new/schema';
import { BroadcastsNewRouteView } from '@/pages/workspaces/broadcasts/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The Broadcasts create form. The `broadcasts_` (trailing underscore) segment keeps it out of the
 * `broadcasts.tsx` layout, so the list's frame doesn't render around it.
 */
function BroadcastsNewRoute() {
  return (
    <LastWorkspaceResolver>
      <BroadcastsNewRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/broadcasts_/new')({
  component: BroadcastsNewRoute,
  validateSearch: validateCreateBroadcastSearch,
});
